(() => {
  'use strict';
  if (window.AWP1Runtime?.version) return;

  const track = (name, payload = {}) => {
    try { window.AWAnalytics?.track?.(name, payload); } catch (_) {}
  };
  const text = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();
  const normalize = (value = '') => String(value)
    .replace(/[₂²]/g, '2')
    .replace(/[₀⁰]/g, '0')
    .trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  const normalizedList = (values) => (Array.isArray(values) ? values : [])
    .map((value) => normalize(value?.system?.handle || value?.handle || value?.nom?.value || value))
    .filter(Boolean);
  const productHandleFromPath = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  };
  const productHandleFromUrl = (href = '') => {
    const match = String(href).match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  };
  const trackerCluster = (node) => {
    const explicit = node?.dataset?.awP1Cluster || '';
    if (explicit) return explicit;
    const holder = node?.closest?.('[data-aw-pdp-universe]');
    if (!holder) return '';
    const universe = holder.dataset.awPdpUniverse || 'generic';
    if (holder.matches('.aw-complementary-products')) return `pdp_complementary_${universe}`;
    if (holder.matches('.aw-product-recommendations')) return `pdp_related_${universe}`;
    return `pdp_${universe}`;
  };

  let pendingPack = null;
  let pendingPdp = null;
  let pendingRecommendation = null;

  const contextFields = {
    platform: 'Plateforme AW',
    manufacturer: 'Fabricant AW',
    type: 'Type de réplique AW',
    status: 'Statut Compatibility AW'
  };

  const selectedLabel = (select) => select?.value ? text(select.options?.[select.selectedIndex]?.textContent || select.value) : '';
  const readProductCompatibility = (root = document) => {
    const node = root.querySelector?.('[data-aw-product-compatibility]') || document.querySelector('[data-aw-product-compatibility]');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return {}; }
  };
  const contextSupported = (productData = {}, context = {}) => {
    const platform = normalize(context.platformKey || context.platform || '');
    if (!platform) return false;
    const platforms = normalizedList(productData.platforms);
    if (platforms.length && !platforms.includes(platform)) return false;

    const manufacturer = normalize(context.manufacturerKey || context.manufacturer || '');
    const manufacturers = normalizedList(productData.manufacturers);
    if (manufacturer && manufacturers.length && !manufacturers.includes(manufacturer)) return false;

    const type = normalize(context.typeKey || context.type || '');
    const types = normalizedList(productData.replicaTypes);
    if (type && types.length && !types.includes(type)) return false;
    return true;
  };
  const readContext = () => {
    const compatibility = document.querySelector('[data-aw-compatibility]');
    if (!compatibility) return null;
    const platform = compatibility.querySelector('[data-aw-platform-select]');
    if (!platform?.value) return null;
    const manufacturer = compatibility.querySelector('[data-aw-manufacturer-select]');
    const type = compatibility.querySelector('[data-aw-replica-type-select]');
    const statusText = text(compatibility.querySelector('[data-aw-title]')?.textContent);
    const context = {
      platform: selectedLabel(platform),
      platformKey: text(platform.value),
      manufacturer: selectedLabel(manufacturer),
      manufacturerKey: text(manufacturer?.value),
      type: selectedLabel(type),
      typeKey: text(type?.value),
      status: statusText && statusText !== 'Vérifiez la compatibilité' ? statusText : ''
    };
    context.supported = contextSupported(readProductCompatibility(compatibility), context);
    return context;
  };

  const mainProductForm = () => document.querySelector('[data-product-root] form.product-form[action*="/cart/add"], [data-product-root] form[action*="/cart/add"]');
  const addContextInput = (form, name, value) => {
    if (!form || !value) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${name}]`;
    input.value = value;
    input.dataset.awP1ContextInput = 'true';
    form.append(input);
  };
  const placeContextCard = (card, form) => {
    if (!card || !form) return;
    const decisionZone = form.closest('[data-aw-pdp-decision-zone]');
    if (!decisionZone) {
      form.after(card);
      return;
    }
    const next = decisionZone.nextElementSibling;
    const proof = next?.matches?.('.aw-pdp-post-decision-proof') ? next : null;
    (proof || decisionZone).after(card);
  };

  const ensureContextCard = () => {
    if (!document.querySelector('[data-aw-compatibility]')) return null;
    const root = document.querySelector('[data-product-root]');
    const form = mainProductForm();
    if (!root || !form) return null;
    let card = root.querySelector('[data-aw-p1-cart-context]');
    if (card) {
      if (form.closest('[data-aw-pdp-decision-zone]')?.contains(card)) placeContextCard(card, form);
      return card;
    }
    card = document.createElement('div');
    card.className = 'aw-p1-cart-context';
    card.dataset.awP1CartContext = 'true';
    card.hidden = true;
    card.innerHTML = '<div class="aw-p1-cart-context__head"><span>Contexte Compatibility AW</span><strong data-aw-p1-context-platform></strong></div><p data-aw-p1-context-detail></p><button type="button" data-aw-p1-context-edit>Modifier ou vérifier le profil</button>';
    placeContextCard(card, form);
    return card;
  };
  const renderContext = (context) => {
    const card = ensureContextCard();
    if (!card) return;
    card.hidden = !context;
    if (!context) return;
    card.dataset.awContextSupported = context.supported ? 'true' : 'false';
    const platform = card.querySelector('[data-aw-p1-context-platform]');
    const detail = card.querySelector('[data-aw-p1-context-detail]');
    if (platform) platform.textContent = context.platform;
    if (detail) {
      const parts = [context.manufacturer, context.type, context.status].filter(Boolean);
      if (context.supported) {
        detail.textContent = `${parts.length ? `${parts.join(' · ')}. ` : ''}Ce contexte correspond aux données Compatibility AW de ce produit et peut être joint à l’article dans le panier.`;
      } else {
        detail.textContent = `${parts.length ? `${parts.join(' · ')}. ` : ''}Profil comparé uniquement : ce contexte ne correspond pas aux données Compatibility AW de ce produit et ne sera pas joint au panier.`;
      }
    }
  };
  const syncContext = () => {
    const form = mainProductForm();
    if (!form) return null;
    form.querySelectorAll('[data-aw-p1-context-input]').forEach((node) => node.remove());
    const context = readContext();
    if (context?.supported) {
      addContextInput(form, contextFields.platform, context.platform);
      addContextInput(form, contextFields.manufacturer, context.manufacturer);
      addContextInput(form, contextFields.type, context.type);
      addContextInput(form, contextFields.status, context.status);
    }
    renderContext(context);
    return context;
  };
  const clearContext = () => {
    document.querySelectorAll('[data-aw-p1-context-input]').forEach((node) => node.remove());
    renderContext(null);
  };

  const initProductUtilities = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-product-root]')) roots.push(scope);
    scope.querySelectorAll?.('[data-product-root]').forEach((root) => roots.push(root));
    roots.forEach((root) => {
      const quantity = root.querySelector('.product-quantity input[type="number"]');
      if (quantity && quantity.dataset.awQuantityNormalized !== 'true') {
        quantity.dataset.awQuantityNormalized = 'true';
        const normalizeQuantity = () => {
          const min = Math.max(Number(quantity.min) || 1, 1);
          if (!Number.isFinite(Number(quantity.value)) || Number(quantity.value) < min) quantity.value = String(min);
        };
        quantity.addEventListener('change', normalizeQuantity);
        quantity.addEventListener('blur', normalizeQuantity);
      }

      if (root.dataset.awStickyBuyReady !== 'true') {
        root.dataset.awStickyBuyReady = 'true';
        const sticky = document.querySelector('[data-sticky-buy]');
        const form = root.querySelector('.product-form');
        if (sticky && form && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { rootMargin: '-90px 0px 0px' });
          observer.observe(form);
        }
      }
    });

    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && drawer.dataset.awP1A11yReady !== 'true') {
      drawer.dataset.awP1A11yReady = 'true';
      const panel = drawer.querySelector('[data-cart-panel]');
      const note = drawer.querySelector('.cart-drawer__note');
      if (note) note.id = note.id || 'CartDrawerNote';
      if (panel && note) panel.setAttribute('aria-describedby', note.id);
    }
  };

  const initPdpContext = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-product-root][data-aw-pdp-universe]')) roots.push(scope);
    scope.querySelectorAll?.('[data-product-root][data-aw-pdp-universe]').forEach((root) => roots.push(root));
    roots.forEach((root) => {
      if (root.dataset.awP1PdpTracked === 'true') return;
      root.dataset.awP1PdpTracked = 'true';
      track('pdp_context_viewed', {
        product_handle: productHandleFromPath(),
        universe: root.dataset.awPdpUniverse || 'generic',
        has_compatibility: Boolean(document.querySelector('[data-aw-compatibility]')),
        has_compatible_pack: Boolean(document.querySelector('[data-aw-compatible-products]')),
        has_atelier_bridge: Boolean(document.querySelector('[data-aw-pdp-context^="atelier"]'))
      });
    });
  };

  const packSnapshot = (button) => {
    const root = button?.closest?.('[data-aw-compatible-products]');
    if (!root) return null;
    const checked = root.querySelectorAll('[data-aw-product-checkbox]:checked').length;
    const quick = button.matches?.('[data-aw-quick-add]');
    const instanceConfig = root.awCatalogCompatibility?.config || {};
    let platform = String(instanceConfig.platform || '');
    let manufacturer = String(instanceConfig.manufacturer || '');
    let replicaType = String(instanceConfig.type || '');
    if (!platform) {
      try {
        platform = localStorage.getItem(root.dataset.storageKey || 'aw_selected_platform') || root.dataset.defaultPlatform || '';
        manufacturer = localStorage.getItem(root.dataset.manufacturerKey || 'aw_selected_manufacturer') || '';
        replicaType = localStorage.getItem(root.dataset.typeKey || 'aw_selected_replica_type') || '';
      } catch (_) {}
    }
    return { item_count: quick ? 1 : checked, platform, manufacturer, replica_type: replicaType, action: quick ? 'quick_add' : 'add_selected', time: Date.now() };
  };

  const recommendationSnapshot = (form) => {
    const holder = form.closest?.('.aw-complementary-products[data-aw-pdp-universe],.aw-product-recommendations[data-aw-pdp-universe]');
    if (!holder) return null;
    const card = form.closest('[data-aw-recommendation-universe]');
    const link = card?.querySelector('a[href*="/products/"]');
    return {
      source: holder.matches('.aw-complementary-products') ? 'complementary' : 'related',
      universe: holder.dataset.awPdpUniverse || 'generic',
      recommended_universe: card?.dataset.awRecommendationUniverse || 'generic',
      product_handle: productHandleFromUrl(link?.getAttribute('href') || ''),
      variant_id: form.querySelector('[name="id"]')?.value || '',
      quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
      time: Date.now()
    };
  };

  document.addEventListener('click', (event) => {
    const tracked = event.target.closest?.('[data-aw-p1-track]');
    if (tracked) {
      track(tracked.dataset.awP1Track || 'p1_click', { cluster: trackerCluster(tracked), href: tracked.getAttribute('href') || '', label: text(tracked.textContent).slice(0, 120) });
    }
    if (event.target.closest?.('[data-aw-p1-context-edit]')) document.querySelector('[data-aw-compatibility]')?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });

    const packButton = event.target.closest?.('[data-aw-compatible-products] [data-aw-quick-add],[data-aw-compatible-products] [data-aw-add-selected]');
    if (!packButton) return;
    const snapshot = packSnapshot(packButton);
    if (!snapshot || snapshot.item_count < 1) return;
    pendingPack = snapshot;
    track('compatible_pack_add_intent', snapshot);
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-product-root][data-aw-pdp-universe] [data-variant-select]');
    if (!select) return;
    const root = select.closest('[data-product-root]');
    track('pdp_variant_changed', { product_handle: productHandleFromPath(), universe: root?.dataset.awPdpUniverse || 'generic', variant_id: select.value || '' });
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !String(form.action || '').includes('/cart/add')) return;
    const recommendation = recommendationSnapshot(form);
    if (recommendation) {
      pendingRecommendation = recommendation;
      track('pdp_recommendation_add_to_cart_intent', recommendation);
      return;
    }
    const root = form.closest?.('[data-product-root][data-aw-pdp-universe]');
    if (!root) return;
    const context = syncContext();
    if (context?.supported) {
      track('pdp_add_with_aw_context', { platform: context.platformKey, manufacturer: context.manufacturerKey, replica_type: context.typeKey, status: context.status });
    } else if (context) {
      track('pdp_aw_context_rejected', { platform: context.platformKey, manufacturer: context.manufacturerKey, replica_type: context.typeKey, status: context.status, reason: 'not_supported_by_product' });
    }
    const snapshot = { product_handle: productHandleFromPath(), universe: root.dataset.awPdpUniverse || 'generic', variant_id: form.querySelector('[name="id"]')?.value || '', quantity: Number(form.querySelector('[name="quantity"]')?.value || 1), time: Date.now() };
    pendingPdp = snapshot;
    track('pdp_add_to_cart_intent', snapshot);
  }, true);

  document.addEventListener('cart:updated', () => {
    const now = Date.now();
    if (pendingPack && now - pendingPack.time <= 20000) { track('compatible_pack_added', pendingPack); pendingPack = null; }
    if (pendingPdp && now - pendingPdp.time <= 20000) { track('pdp_add_to_cart', pendingPdp); pendingPdp = null; }
    if (pendingRecommendation && now - pendingRecommendation.time <= 20000) { track('pdp_recommendation_add_to_cart', pendingRecommendation); pendingRecommendation = null; }
  });

  addEventListener('aw:compatibility-changed', () => {
    const context = syncContext();
    if (context?.supported) {
      track('pdp_aw_context_ready', { platform: context.platformKey, manufacturer: context.manufacturerKey, replica_type: context.typeKey, status: context.status });
    } else if (context) {
      track('pdp_aw_context_rejected', { platform: context.platformKey, manufacturer: context.manufacturerKey, replica_type: context.typeKey, status: context.status, reason: 'not_supported_by_product' });
    }
  });
  addEventListener('aw:platform-reset', clearContext);

  const init = (scope = document) => {
    initPdpContext(scope);
    initProductUtilities(scope);
    if (document.querySelector('[data-product-root]') && document.querySelector('[data-aw-compatibility]')) syncContext();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  window.AWP1Runtime = { version: '3.2.0', init, syncContext, readContext, contextSupported, policy: 'product-supported-context-only' };
  window.AWP1CommerceContext = { version: '3.2.0', sync: syncContext };
})();
